import React from "react";
import TextField from "@material-ui/core/TextField";
import Modal from "components/Tvendo/Common/ModalBase";

export default function ModalVisitDay(props) {
  const visitDay = props.model;

  return (
    <Modal
      title="Día de Visita"
      model={visitDay}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="base/visit-day"
    >
      <TextField
        label="Código"
        fullWidth
        type="number"
        name="code"
        margin="normal"
        defaultValue={!!visitDay ? visitDay.code : ""}
        required
      />
      <TextField
        label="Descripción"
        fullWidth
        type="text"
        name="description"
        margin="normal"
        defaultValue={!!visitDay ? visitDay.description : ""}
        required
      />
    </Modal>
  );
}
